<h3 class="font-style" >Congrats your order is on the way!</h3>
<h4 class="font-style" >Online Payment Code: {{paymentid}}</h4>

<img src="assets/images/scooter-running.gif" class="img-style" >